import {ChangeDetectorRef, Directive, effect, ElementRef, inject} from '@angular/core';
import {PortfolioSegmentDataContext} from '../data/portfolio-segment-data-context.service';
import {
    SEGMENT_DATA_OBSERVER_HOST,
    SegmentDataObserverHost,
    SegmentDataObserverHostBase
} from './segment-data-observer.token';

@Directive({
    selector: '[appSegmentDataObserver]',
})
export class SegmentDataObserverDirective {

    private readonly hostComponent = (inject(ChangeDetectorRef) as any).context as SegmentDataObserverHost;
    private readonly pfSegData = inject(PortfolioSegmentDataContext);
    private initialized = false;

    constructor() {
        if (this.hostComponent.onAccountDataChanged == undefined) {
            console.error('Host component does not implement SegmentDataObserverHost interface');
        } else {
            effect(() => this.formulaEvaluationListener());
        }
    }

    private formulaEvaluationListener() {
        const formulaEvalStatus = this.pfSegData.accountDataFormulaEvaluation.status();
        const formulaEvalResult = this.pfSegData.accountDataFormulaEvaluation.value();
        if (!this.initialized) {
            // ignore first evaluation as its the registering of the effect
            this.initialized = true;
        } else if (formulaEvalStatus === 'resolved' || formulaEvalStatus === 'local') {
            console.log('Values:', formulaEvalResult?.debugInfo);
        }
    }
}
